<div class="team-dialog__container">
  <h2>
    @if (teamHasId) {
      <mat-icon svgIcon="pencil-outline"></mat-icon>
      Edit Team
    } @else {
      <mat-icon svgIcon="plus"></mat-icon>
      Create Team
    }
  </h2>

  <div class="team-dialog__input-container">
    <oph-input-orange
      [control]="$any(teamFg.get('name'))"
      [inputStyle]="{height: '50px', fontSize: '16px'}"
      placeholder="Team name"
    ></oph-input-orange>
    @if (teamFg.get('name')?.errors?.['duplicateName']) {
      <span class="team-dialog__error-message">A team with this name already exists.</span>
    }
  </div>

  <oph-dialog-footer
    [labels]="footerActionLabels()"
    [menuOptions]="menuOptions"
    [hideMenu]="!teamHasId"
    [loading]="isLoading"
    (cancel)="onCancel()"
    (save)="onSave()"
    (menuOption)="onMenuOption($event)"
  />
</div>
